import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { ListParterDiscountCode, NewReferral, PartnerDiscountCode } from '@models/partner/client-setup/partner-client-setup';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PartnerClientSetUpService {
  private readonly baseUrl;
  private urlPrefix = 'partner-setup/';

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getPartnerUrl(): Observable<string> {
    const urlResource = this.baseUrl + this.urlPrefix + 'get-partner-url';
    return this.httpClient.get<string>(urlResource);
  }

  getPromoCodes(): Observable<ListParterDiscountCode> {
    const urlResource = this.baseUrl + this.urlPrefix + 'get-promo-codes';
    return this.httpClient.get<Response>(urlResource).pipe(
      map(data => {
        return ListParterDiscountCode.deserialize({
          data: (data && (data as any) ? ((data as any) as Array<string>) : []).map(item => PartnerDiscountCode.deserialize(item))
        });
      })
    );
  }

  addPromoCode(newCode: PartnerDiscountCode) {
    const urlResource = this.baseUrl + this.urlPrefix + 'add-promo-code';
    return this.httpClient.post(urlResource, newCode, { responseType: 'text' as 'json' });
  }

  createReferral(newReferral: NewReferral) {
    const urlResource = this.baseUrl + this.urlPrefix + 'create-referral';
    return this.httpClient.post(urlResource, newReferral, { responseType: 'text' as 'json' });
  }
}
